import React from 'react';
import { createRoot } from 'react-dom/client';
import ChrPropTypes from '../../ChrPropTypes';
import PropsExtractor from '../../PropsExtractor';
import AppInitializer from '../../../components/specific/Events/custom/listing/AppInitializer';
import { Provider } from '../../../chronusStore/helper';
import { chronusStore } from '../../../chronusStore';

export default class EventsListingRenderer {
  static renderEventsApp = (elementId) => {
    const node = document.getElementById(elementId);
    const dataFromElement = PropsExtractor.getForList(node, {
      "rsvpStatusMap": ChrPropTypes.object,
      "eventsFetchUrl": ChrPropTypes.string,
      "todayButtonTooltip": ChrPropTypes.string,
      "view": ChrPropTypes.object,
      "initialState": ChrPropTypes.object,
      "pageActions": ChrPropTypes.array,
      "tabKeyFilterDataMap": ChrPropTypes.object,
      "eventDetailsUrl": ChrPropTypes.string,
      "emptyEventsContent": ChrPropTypes.string,
      "globalEventsLink": ChrPropTypes.object,
      "calendarTimeZone": ChrPropTypes.string,
      "initialDate": ChrPropTypes.string,
      "tabKeyLabelMap": ChrPropTypes.object,
      "topBarTitle": ChrPropTypes.string,
      "tabKeyInfoDetailsMap": ChrPropTypes.object
    });
    const root = createRoot(node);

    root.render(
      <Provider store={ chronusStore }>
        <AppInitializer data={ dataFromElement } />
      </Provider>
    );
  };
}
